import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormHelperText, Box, Typography, Button } from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { StyledFileInput, StyledLabel } from "./StyleInputs";
import PlaceHolderImage from "./placeholder.svg";

const ImageUploadField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;
  const [preview, setPreview] = useState(null);

  return (
    <Box sx={{ mb: 3 }}>
      <StyledLabel required={field.required}>{field.label}</StyledLabel>
      <Controller
        name={field.id}
        control={control}
        defaultValue={null}
        rules={{
          required: field.required ? `${field.label} is required` : false,
          validate: (value) => {
            if (!value)
              return field.required ? `${field.label} is required` : true;
            if (field.maxSize && value.size > field.maxSize) {
              return `File size must be less than ${field.maxSize / 1000000}MB`;
            }
            return true;
          },
        }}
        render={({ field: { onChange, value, ref } }) => (
          <>
            <StyledFileInput>
              <input
                type="file"
                hidden
                accept={field.accept || "image/*"}
                onChange={(e) => {
                  const file = e.target.files?.[0] || null;
                  onChange(file);
                  if (file) {
                    setPreview(URL.createObjectURL(file));
                  } else {
                    setPreview(null);
                  }
                }}
                ref={ref}
                id={`file-upload-${field.id}`}
              />
              <label htmlFor={`file-upload-${field.id}`}>
                <Button
                  component="span"
                  startIcon={<CloudUpload />}
                  sx={{
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  Upload Image
                </Button>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ mt: 1 }}
                >
                  {value?.name || "Click to browse"}
                </Typography>
              </label>
            </StyledFileInput>

            {preview && (
              <Box sx={{ mt: 2, mb: 2 }}>
                <img
                  src={preview || PlaceHolderImage}
                  alt="Preview"
                  style={{
                    display: "block",
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                    borderRadius: "4px",
                    border: "1px solid #E5E7EB",
                  }}
                />
              </Box>
            )}
            {errorMessage && (
              <FormHelperText error>{errorMessage}</FormHelperText>
            )}
          </>
        )}
      />
    </Box>
  );
};

export default ImageUploadField;
